import { jsxs as e, jsx as t } from "react/jsx-runtime";

import { useMemo as n } from "react";

import a from "@ui-components-3/icons/lib/solid/ChevronLeft";

import o from "@ui-components-3/icons/lib/solid/ChevronRight";

import i from "../../hooks/useTableContext/index.js";

import r from "../../../../utils/classNames/index.js";

import { COLOR_VARIANT_TEXT_CLASSES as s } from "../../constants/index.js";

/*
 * TODOs:
 *  should we allow custom actions/states to be passed to Pagination for use w/out model?
 */ const l = ({className: l, ...d}) => {
    const {model: p, colorVariant: c, scrollToTop: m} = i();
    if ("production" !== process.env.NODE_ENV && !p) throw new Error('Pagination component is only supported within tables using "useTable"');
    const u = n((() => p?.getState()), [ p ]);
    if (!u) return null;
    const g = n((() => ("client" === p?.paginationType ? p?.getFilteredRowModel().rows.length : p?.getRowCount()) || 0), [ p ]), b = n((() => {
        return e = u.pagination.pageIndex, t = u.pagination.pageSize, (e > 0 ? e * t : e) + 1;
        var e, t;
    }), [ u.pagination ]), x = n((() => {
        const e = (t = u.pagination.pageIndex, n = u.pagination.pageSize, t > 0 ? t * n + n : t + n);
        var t, n;
        return e > g ? g : e;
    }), [ u.pagination, g ]), h = p?.isLoading, f = h || !p?.getCanPreviousPage(), N = h || !p?.getCanNextPage() || x >= g;
    return e("div", {
        ...d,
        className: r("gap-m flex items-center", l),
        children: [ e("p", {
            className: "typography-body-l text-neutral min-w-[160px] text-right",
            children: [ b, "-", x, " of ", g ]
        }), e("div", {
            className: "gap-m flex",
            children: [ t("button", {
                type: "button",
                onClick: () => {
                    p?.previousPage(), m();
                },
                disabled: f,
                className: r("btn-unsized btn-neutral-borderless disabled:bg-transparent disabled:text-neutral-400", s[c]),
                "aria-label": "Go To Previous Page",
                children: t(a, {
                    "aria-hidden": "true",
                    className: "m-xs h-[18px] w-auto shrink-0"
                })
            }), t("button", {
                type: "button",
                onClick: () => {
                    p?.nextPage(), m();
                },
                disabled: N,
                className: r("btn-unsized btn-neutral-borderless disabled:bg-transparent disabled:text-neutral-400", s[c]),
                "aria-label": "Go To Next Page",
                children: t(o, {
                    "aria-hidden": "true",
                    className: "m-xs h-[18px] w-auto shrink-0"
                })
            }) ]
        }) ]
    });
};

export { l as default };
//# sourceMappingURL=index.js.map
